import { mapState } from "vuex";
export default {
	name: 'App',
	data() {
		return {
			AppLoading: false,
			ORIGINURL: window.location.host == this.domainSet  ? this.CON_LOCATION : window.location.host,
			domainSet: "localhost:8002"
		}
	},
	mounted() {
		//自适应处理
		window.onresize = () => {
			return(() => {
				window.fullHeight = document.documentElement.clientHeight;
				window.fullWidth = document.documentElement.clientWidth;
				this.$store.commit('updataFullScreen', window);
			})();
		};
		this.isIE();
		if(this.isNull(this.CompanyOPT) || this.isNull(this.Company.SiteName)) {
			this.getCompany();
		};
		if(!this.isNull(this.getQueryVariable('code')) && !this.$store.state.isLogin) {
			this.$router.push({
				path: "/Login"
			});
		};
		if(this.$store.state.isLogin && !this.isNull(this.userInfo) && this.userInfo.NeedChangePass) {
			this.$router.push({
				path: "/UpdatePwd"
			});
		};
	},
	methods: {
		getCompany() {
			const _this = this;
			_this.AppLoading = true;
			_this.axios.post(_this.BASE_API + "User/GetSiteList")
				.then(function(response) {
					if(response.IsSuccess) {
						let companInfo = {};
						_this.$store.commit('sessionCompanyOPT', response.ResultObject);
						response.ResultObject.forEach(function(items) {
							if(!_this.isNull(items.DomainBX)) {
								if(items.DomainBX === _this.location) {
									companInfo = items;
								}
							}
						});
						_this.$store.commit('sessionCompany', companInfo);
						_this.AppLoading = false;
					} else {
						_this.showMsg("无法获取子公司信息，请确认是否在内网状态下！", 'error');
					}
				}).catch(function(error) {
					_this.showMsg("无法获取子公司信息，请确认是否在内网状态下！", 'error');
				})
		},
		isIE() {
			if(!!window.ActiveXObject || "ActiveXObject" in window) {
				this.$alert('自2015年3月起，微软已宣布弃用IE，且不再对IE提供任何更新维护。为便捷日后操作，可设置您的电脑默认浏览器为谷歌、火狐、Edge或搜狗！', '温馨提示', {
					showClose: false,
					showConfirmButton: false,
					duration: 0,
					type: "warning",
					center: true
				});
			}
		}
	},
	computed: {
		...mapState(["BASE_API", "CompanyOPT", "Company", "userInfo", "userRole", "CON_LOCATION"]),
		location() {
			return window.location.host == this.domainSet || window.location.host ==  "172.28.2.60:8002" ? this.CON_LOCATION : window.location.host
		}
	},
	watch: {
		'$route': function(newVal, oldVal) {
			if(newVal && !this.isNull(newVal.meta.isLogin)) {
				if(this.userInfo.NeedChangePass) {
					this.$router.push({
						path: "/UpdatePwd"
					});
				}
			}
		},
		'userInfo': function(newVal, oldVal) {
			return newVal
		},
	}
}


// WEBPACK FOOTER //
// ./src/view/app.js